const { addDomainPrefix } = require('../../shared/utils/addDomainPrefix');

const WORDPRESS_INTEGRATION = 'wordpress';
const W3SCHOOLS_INTEGRATION = 'w3schools';
const ADALO_INTEGRATION = 'adalo';
const ELEMENTOR_INTEGRATION = 'elementor';
const WOO_INTEGRATION = 'woo';
const APP_NAME = 'integration_landing_page';
const DOMAIN_APP_NAME = addDomainPrefix(APP_NAME);

const INTEGRATIONS_MAP = {
    [WORDPRESS_INTEGRATION]: {
        APP_NAME: 'wordpress_landing_page',
        PAGE_TITLE: 'Create a Logo for Your WordPress.com Website - Fiverr',
        TOP_LEVEL_SOURCE: 'WordPress',
        PAGE_ELEMENT_TYPE: 'WordPress',
        HERO_TITLE:
            'makers_experience_perseus.integration_landing_page.header.page_title',
    },
    [W3SCHOOLS_INTEGRATION]: {
        APP_NAME: 'w3schools_landing_page',
        PAGE_TITLE: 'Create a Logo for your website - Fiverr',
        TOP_LEVEL_SOURCE: 'W3Schools',
        PAGE_ELEMENT_TYPE: 'W3Schools',
        HERO_TITLE:
            'makers_experience_perseus.integration_landing_page.header.page_title',
    },
    [ADALO_INTEGRATION]: {
        APP_NAME: 'adalo_landing_page',
        PAGE_TITLE: 'Create a Logo for your app - Fiverr',
        TOP_LEVEL_SOURCE: 'Adalo',
        PAGE_ELEMENT_TYPE: 'Adalo',
        HERO_TITLE:
            'makers_experience_perseus.integration_landing_page.header.adalo_page_title',
    },
    [ELEMENTOR_INTEGRATION]: {
        APP_NAME: 'elementor_landing_page',
        PAGE_TITLE: 'Create a Logo for your website - Fiverr',
        TOP_LEVEL_SOURCE: 'Elementor',
        PAGE_ELEMENT_TYPE: 'Elementor',
        HERO_TITLE:
            'makers_experience_perseus.integration_landing_page.header.page_title',
    },
    [WOO_INTEGRATION]: {
        APP_NAME: 'woo_landing_page',
        PAGE_TITLE: 'Create a Logo for your store - Fiverr',
        TOP_LEVEL_SOURCE: 'Woo',
        PAGE_ELEMENT_TYPE: 'Woo',
        HERO_TITLE:
            'makers_experience_perseus.integration_landing_page.header.woo_page_title',
    },
};

const FAQ_CONTENT = [
    {
        defaultExpanded: false,
        question: 'How does the Logo Maker work?',
        answer: 'We’ll ask you a few questions about your business and style preferences. Then we’ll put to work our powerful AI technology to create logo designs that best fit your brand, based on a wide selection of hand-made designs.',
    },
    {
        defaultExpanded: false,
        question: 'How long does it take to create my logo?',
        answer: 'Just a few moments! Our technology reduces the complex process of designing a logo for your business into a matter of seconds.',
    },
    {
        defaultExpanded: false,
        question:
            'What do you mean by “logos made by talented designers on Fiverr”?',
        answer: 'All of the logo designs we suggest are based on the beautiful work of top designers on Fiverr, adjusted to your needs with the power of Artificial Intelligence (AI).',
    },
    {
        defaultExpanded: false,
        question: 'Can I use the Logo Maker for free?',
        answer: 'You can use the Logo Maker to create a logo and customize it at no cost. Once you have a logo you love, you can buy it by selecting one of our branding packages (starting from US$30) and instantly download the logo in any format you need.',
    },
    {
        defaultExpanded: false,
        question: 'What’s included in the logo branding packages? ',
        answer: 'You’ll get your logo in different formats, sizes, and colors that work across all your digital assets. You can also get a social media kit and brand guidelines - depending on your business needs. See our logo branding packages.',
    },
    {
        defaultExpanded: false,
        question:
            'I need help from a professional designer to customize my logo. What can I do?',
        answer: 'You can order customization services from the designer of your logo after buying the logo.',
    },
    {
        defaultExpanded: false,
        question: 'Where can I use my logo?',
        answer: 'Anywhere you want! You’ll get full commercial and non-commercial rights to use your logo anywhere you want to promote your business or brand.',
    },
];
const BASE_APP_NAME = 'buyer_landing_page';
const PAGE_DESCRIPTION =
    'Fiverr online logo maker matches you with beautiful, hand-crafted logos. Get an affordable custom logo and all the branding files you need in just a few minutes!';
const LOGO_MAKER_LOGO =
    'https://fiverr-res.cloudinary.com/image/upload/q_auto,f_png/v1/attachments/generic_asset/asset/d9062a8d899e482795eff725cfd92c94-1577358899413/logo_maker_logo.svg';
const TWITTER_ACCOUNT = '@fiverr';

const SCHEMA_MARKUP = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ_CONTENT.map((content) => ({
        '@type': 'Question',
        name: content.question,
        acceptedAnswer: {
            '@type': 'Answer',
            text: content.answer,
        },
    })),
};

const getIntegrationSeoContent = (integration) => {
    const PAGE_TITLE =
        INTEGRATIONS_MAP[integration] &&
        INTEGRATIONS_MAP[integration].PAGE_TITLE;

    const TWITTER_TAGS = {
        card: 'summary',
        title: PAGE_TITLE,
        description: PAGE_DESCRIPTION,
        site: TWITTER_ACCOUNT,
        creator: TWITTER_ACCOUNT,
        image: LOGO_MAKER_LOGO,
    };

    const OG_TAGS = {
        url: 'https://www.fiverr.com/logo-maker',
        description: PAGE_DESCRIPTION,
        title: PAGE_TITLE,
        image: LOGO_MAKER_LOGO,
    };

    return { PAGE_TITLE, OG_TAGS, TWITTER_TAGS };
};

const SCHEMA_MARKUP_HTML = `<script type="application/ld+json">${JSON.stringify(
    SCHEMA_MARKUP
)}</script>`;

module.exports = {
    getIntegrationSeoContent,
    DOMAIN_APP_NAME,
    PAGE_DESCRIPTION,
    FAQ_CONTENT,
    BASE_APP_NAME,
    SCHEMA_MARKUP_HTML,
    INTEGRATIONS_MAP,
    WORDPRESS_INTEGRATION,
    W3SCHOOLS_INTEGRATION,
    ADALO_INTEGRATION,
    ELEMENTOR_INTEGRATION,
    WOO_INTEGRATION,
};
